/* SENSUS FIXES – ES5 SAFE */

document.documentElement.classList.add('sensus-ready');

(function () {
  try { console.log('[SENSUS FIXES] running v2026-02-18-es5'); } catch(e){}

  /* -------------------------
     A) Helpers
  ------------------------- */
  function hasClass(el, cls) {
    if (!el || !el.className) return false;
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }

  function addClass(el, cls) {
    if (!el) return;
    if (hasClass(el, cls)) return;
    el.className = (el.className ? el.className + ' ' : '') + cls;
  }

  function closestByClass(el, cls) {
    while (el && el !== document.documentElement) {
      if (hasClass(el, cls)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function normalizeUrl(u) {
    if (!u) return u;
    if (u.indexOf('//') === 0) return 'https:' + u;
    return u;
  }

  function hideNode(el, key) {
    if (!el) return;
    el.setAttribute('data-sensus-hidden', key);
    el.style.display = 'none';
  }

  function showNodesByKey(key) {
    var nodes = document.querySelectorAll('[data-sensus-hidden="' + key + '"]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.display = '';
      nodes[i].removeAttribute('data-sensus-hidden');
    }
  }

  /* -------------------------
     B) Ocultar competidores
  ------------------------- */

  // 1) Oculta competidores “normales” y los libera tras 2 rAF
  function hideCompetitorsNow() {
    var sels = [
      '.wt-announcement',
      '.wt-announcement__body',
      '.body-wt-announcement',
      '.wt-logo-banner__additional',
      '.wt-localization-trigger',
      'img.wt-flag-icon'
    ];

    for (var i = 0; i < sels.length; i++) {
      var nodes = document.querySelectorAll(sels[i]);
      for (var j = 0; j < nodes.length; j++) hideNode(nodes[j], 'base');
    }
  }

  function showCompetitorsAfterPaint() {
    showNodesByKey('base');
  }

  // 2) Oculta hero__link y NO lo libera aquí (se libera cuando el poster cargue)
  function hideHeroLinkNow() {
    var a = document.querySelectorAll('a.hero__link');
    for (var i = 0; i < a.length; i++) hideNode(a[i], 'herolink');
  }

  function showHeroLink() {
    showNodesByKey('herolink');
  }

  hideCompetitorsNow();
  hideHeroLinkNow();

  if (window.requestAnimationFrame) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        showCompetitorsAfterPaint();
      });
    });
  } else {
    setTimeout(showCompetitorsAfterPaint, 120);
  }

  /* -------------------------
     C) Marcar sensus-ready
  ------------------------- */
  function markReady() {
    try {
      if ((' ' + document.documentElement.className + ' ').indexOf(' sensus-ready ') === -1) {
        document.documentElement.className += ' sensus-ready';
      }
    } catch (e) {}
  }

  if (window.requestAnimationFrame) {
    requestAnimationFrame(function () { requestAnimationFrame(markReady); });
  } else {
    setTimeout(markReady, 50);
  }

  /* -------------------------
     D) Hero video + Poster LCP
  ------------------------- */

  function getHeroVideo() {
    // por tu consola: el hero video lo identificamos por poster “_2400x”
    var vids = document.querySelectorAll('video[poster]');
    for (var i = 0; i < vids.length; i++) {
      var p = vids[i].getAttribute('poster') || '';
      if (p.indexOf('_2400x') > -1) return vids[i];
    }
    return null;
  }

  function ensurePosterLCP(v) {
    if (!v) return;

    var hero = closestByClass(v, 'wt-video__movie') || v.parentElement;
    if (!hero) return;

    var poster = normalizeUrl(v.getAttribute('poster'));
    if (!poster) return;

    // Preload EXACTO del poster del video
    if (!document.querySelector('link[rel="preload"][as="image"][href="' + poster + '"]')) {
      var link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = poster;
      try { link.setAttribute('fetchpriority', 'high'); } catch(e){}
      document.head.appendChild(link);
    }

    // Insert IMG placeholder (si no existe)
    var img = hero.querySelector('img.sensus-hero-poster');
    if (!img) {
      img = document.createElement('img');
      img.className = 'sensus-hero-poster';
      img.alt = '';
      img.src = poster;
      img.loading = 'eager';
      img.decoding = 'async';
      try { img.setAttribute('fetchpriority', 'high'); } catch(e){}
      hero.insertBefore(img, v);
    }

    // Cuando el IMG ya cargó, ya podemos soltar hero__link
    function releaseHeroLinkWhenPosterReady() {
      // suelta hero__link ya que el poster está listo para ganar LCP
      showHeroLink();
    }

    // Si el img ya está completo, libera de una
    if (img && img.complete) {
      releaseHeroLinkWhenPosterReady();
    } else if (img) {
      // espera a load/error (no queremos bloquear UX si falla)
      img.onload = releaseHeroLinkWhenPosterReady;
      img.onerror = releaseHeroLinkWhenPosterReady;
    }

    // Además, timeout de seguridad (por si Shopify cambia el DOM)
    setTimeout(releaseHeroLinkWhenPosterReady, 2500);

    // Ocultar poster cuando el video reproduce
    function hidePoster() { addClass(hero, 'sensus-video-ready'); }

    try {
      if (v.readyState >= 3) { hidePoster(); }
      v.addEventListener('canplay', hidePoster);
      v.addEventListener('playing', hidePoster);
    } catch (e2) {}
  }

  function patchHeroVideo(v) {
    if (!v) return;
    if (v.getAttribute('data-sensus-patched') === '1') return;
    v.setAttribute('data-sensus-patched', '1');

    try { v.autoplay = false; } catch (e) {}
    try { v.removeAttribute('autoplay'); } catch (e) {}
    try { v.preload = 'none'; v.setAttribute('preload', 'none'); } catch (e) {}
    try { v.muted = true; } catch (e) {}
    try { v.playsInline = true; v.setAttribute('playsinline', ''); } catch (e) {}

    try { v.pause(); } catch (e) {}

    setTimeout(function () {
      try { v.setAttribute('preload', 'none'); v.preload = 'none'; } catch (e2) {}
    }, 0);

    function playLater() {
      try { v.preload = 'auto'; v.setAttribute('preload', 'auto'); } catch (e) {}
      try { v.load(); } catch (e) {}
      try {
        var p = v.play();
        if (p && p.catch) p.catch(function(){});
      } catch (e) {}
    }

    if (window.requestAnimationFrame) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (window.requestIdleCallback) {
            requestIdleCallback(playLater, { timeout: 2000 });
          } else {
            setTimeout(playLater, 900);
          }
        });
      });
    } else {
      setTimeout(playLater, 900);
    }
  }

  function fixLogoTransformMobileOnly() {
    var logo = document.querySelector('img.wt-logo-banner__logo');
    if (!logo) return;

    if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
      try { logo.style.transform = 'none'; } catch (e) {}
      try { logo.style.willChange = 'auto'; } catch (e) {}
      try { logo.removeAttribute('fetchpriority'); } catch (e) {}
      try { logo.setAttribute('loading', 'lazy'); } catch (e) {}
    }
  }

  function run() {
    fixLogoTransformMobileOnly();

    var v = getHeroVideo();
    if (!v) return;

    ensurePosterLCP(v);
    patchHeroVideo(v);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  try {
    var mo = new MutationObserver(function () { run(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
